export default "__VITE_ASSET__BFCFjvih__"